import React, { useState, useCallback, useMemo, Component, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import { useFormContext } from 'react-hook-form';
import { getGlobalData, isHauptadmin } from '../../lib/globalData';
import { Button, Create, Datagrid, DeleteButton, Edit, EditButton, 
  FileField, FileInput, Filter, List, ReferenceInput, SaveButton, SelectInput, 
  SimpleForm, TextField, TextInput, Toolbar as RToolbar, useRecordContext, useListContext, useRedirect, 
  useStore, useTranslate } from 'react-admin';
import Move from '../../lib/Move';
import { apiPath } from '../../lib/isTest';
//import CloseToolbar from '../../lib/CloseToolbar';
import BookingsheetCopy from '../../lib/set/BookingsheetCopy';
import NoPagination from '../../lib/NoPagination';
import dataProvider from '../../lib/dataProvider';

import isHotkey from 'is-hotkey'
import { Editable, withReact, Slate, useSlateSelection } from 'slate-react'
import { Editor, Transforms, createEditor, Element as SlateElement } from 'slate'
import { withHistory } from 'slate-history'
import { useInput } from 'ra-core';
import { Toolbar, serialize, deserializeHtml, MarkButton, BlockButton, CButton, Leaf, Element, toggleMark, InsertInput, ParamProvider, ParamContext, DocumentInput } from '../../lib/set/slateComponents'
import { ParentTree } from '../../lib/set/slateSidebar'

import { Dialog, DialogTitle, DialogContent, DialogActions, Drawer, SvgIcon, TextField as MTextField } from '@mui/material';
import { Add as AddIcon, Backspace, Code, FormatAlignCenter, FormatAlignJustify, 
  FormatAlignLeft, FormatAlignRight, FormatBold, FormatItalic, FormatListNumbered, 
  FormatListBulleted, FormatUnderlined, FormatQuote, Fullscreen, Html, LooksOne, 
  LooksTwo, ViewSidebarOutlined } from '@mui/icons-material';

const dataChoices = [
  { id: 'perResGroup',  text: 'bw.set.bookingsheet.perResGroup'}, 
  { id: 'perRes',       text: 'bw.set.bookingsheet.perRes'}, 
  { id: 'perGuest',     text: 'bw.set.bookingsheet.perGuest'}, 
]

const dormbookChoices = [
  { id: 0,  text: 'bw.set.bookingsheet.noAccess'}, 
  { id: 1,  text: 'bw.set.bookingsheet.pdf'}, 
  { id: 2,  text: 'bw.set.bookingsheet.email'}, 
  { id: 3,  text: 'bw.set.bookingsheet.pdf_email'}, 
]

const HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
  'mod+`': 'code',
}

const SlateEditor = ({ source, error='', short=false, ...props }) => {
  const { field, formState } = useInput({ ...props, source });
  const { setVars, setImages } = useContext(ParamContext)
  
  useEffect(() => {
    if(!short){
      dataProvider.getOne('setBookingsheet/get_vars', { id: formState.defaultValues.id, sort: { }, pagination: { page: 1, perPage: 999 }})
      .then(res  => {
        const vars = res.data.data.map((txt, idx) => ({label: txt, id: txt}))
        setVars(vars)
      })
      dataProvider.getList('setImage', { filter: {art: 'bwh.hostel.buchbild'}, sort: { }, pagination: { page: 1, perPage: 999 }})
      .then(res  => {
        setImages(res.data)
      })
    }
    // eslint-disable-next-line
  }, []);

  const editor = useMemo(() => withTables(withImages(withHistory(withReact(createEditor())))), [])
  const [fullscreen, setFullscreen] = useState(false)
  const [head, setHead] = useState({})
  const renderElement = useCallback(props => <Element {...props} fullscreen={fullscreen} />, [fullscreen])
  const renderLeaf = useCallback(props => <Leaf {...props} />, [])
  const [htmlEdit, setHtmlEdit] = useState(error===''?false:true)
  const [first, setFirst] = useState(true)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [ fixed, setFixed ] = useState(0);

  const handleSetFixed = (level) => {
    if(level===0 && fixed!==0)setFixed(level)
    else if(level > fixed)setFixed(level)
  }
  const handleSetHeader = (header) => {
    if(header !== head)setHead(header)
  }

  if(first && error!==""){
    dataProvider.update('setBookingsheet/rend_err', {id: formState.defaultValues.id, data: {err: error, id_hostel:formState.defaultValues.id_hostel, data: deserializeHtml(field.value, formState.defaultValues, handleSetFixed, handleSetHeader)} })
    .then(res  => {
      setFirst(false)
    })
  }

  const handleUpdate = () => {
    if(editor.children.length === 0){
      field.onChange('')
      field.onBlur()
      return
    }

    const html = serialize(editor)
    field.onChange('<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html>'+head+'<body>'+html+'</body></html>')
    field.onBlur()
  }

  const editorContent = (
    <div className={fullscreen?"slateEditor slateEditorFullscreen":"slateEditor"}>
      <Slate 
        editor={editor} 
        initialValue={deserializeHtml(field.value?field.value:'<div>Text ...<div>', formState.defaultValues, handleSetFixed, handleSetHeader)} 
        onChange={handleUpdate} 
        onBlur={handleUpdate}  
      >
        <Toolbar>
          <CButton active={false} action={()=>{Transforms.deselect(editor);setFixed(0);setHtmlEdit(true)}} icon={<Html />} />
          <CButton active={drawerOpen} action={()=>setDrawerOpen(!drawerOpen)} icon={<ViewSidebarOutlined />} />
          <CButton active={fullscreen} action={()=>setFullscreen(!fullscreen)} icon={<Fullscreen />} />
          <InsertButton editor={editor} />
          <MarkButton format="bold" icon={<FormatBold />} />
          <MarkButton format="italic" icon={<FormatItalic />} />
          <MarkButton format="underline" icon={<FormatUnderlined />} />
          <MarkButton format="code" icon={<Code />} />
          <MarkButton format="var" icon={<SvgIcon {...props}>
            <text x="3" y="17" fontFamily="serif" fontSize="20" fontStyle="italic">x</text>
          </SvgIcon>} />
          <BlockButton format="headingone" icon={<LooksOne />} />
          <BlockButton format="headingtwo" icon={<LooksTwo />} />
          <BlockButton format="block-quote" icon={<FormatQuote />} />
          <BlockButton format="numberedlist" icon={<FormatListNumbered />} />
          <BlockButton format="bulletedlist" icon={<FormatListBulleted />} />
          <BlockButton format="left" icon={<FormatAlignLeft />} />
          <BlockButton format="center" icon={<FormatAlignCenter />} />
          <BlockButton format="right" icon={<FormatAlignRight />} />
          <BlockButton format="justify" icon={<FormatAlignJustify />} />
          <DocumentInput editor={editor} values={formState.defaultValues} handleSetFixed={handleSetFixed} handleSetHeader={handleSetHeader} />
        </Toolbar>
        { fixed>0 && fixed<3 && <Warning level={fixed} setFixed={setFixed} handleUpdate={handleUpdate} /> }
        <Editable
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          onKeyDown={event => {
            for (const hotkey in HOTKEYS) {
              if (isHotkey(hotkey, event)) {
                event.preventDefault()
                const mark = HOTKEYS[hotkey]
                toggleMark(editor, mark)
              }
            }
          }}
          style={{
            minWidth: '20em',
            minHeight: '20em',
            border: '1px solid #ccc',
          }}
          onFocus={()=>setDrawerOpen(true)}
          className={fullscreen?'slateEditorContainerFullscreen slateEditorContainer':'slateEditorContainer'}
        />
        <Drawer
          variant="persistent"
          anchor="right"
          sx={{
            flexShrink: 0,
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '30em' },
          }}
          open={drawerOpen}
        >
          {<DrawerContent editor={editor} />}
        </Drawer>
      </Slate>
    </div>
  )
  
  //console.log(deserializeHtml(field.value))
  if(!htmlEdit && !fullscreen)return (
    editorContent
  )
  else if(!htmlEdit && fullscreen)return (
    ReactDOM.createPortal(editorContent, document.body)
  )
  else return (
    <>
      <Toolbar>
        <CButton active={true} action={()=>{setHtmlEdit(false)}} icon={<Html />} />
      </Toolbar>
      { error!==''?<div>{error}</div>:null }
      { fixed>0 && fixed<3 && <Warning level={fixed} setFixed={setFixed} handleUpdate={handleUpdate} /> }
      <textarea style={{ width: error!==''?'100%':'100%', height: error!==''?'100%':'100%', boxSizing: 'border-box' }} rows={34} value={field.value} onChange={(e) => {field.onChange(e.target.value)}} />
    </>
  )
}

const Warning = ({level, setFixed, handleUpdate}) => {
  const { getValues } = useFormContext();
  const tr = useTranslate();
  const style=level===1?
    {
      backgroundColor: 'yellow',
      width: 'fit-content',
      padding: '.7em',
      fontWeight: 'bold'
    }
    :
    {
      backgroundColor: 'red',
      color: 'white',
      width: 'fit-content',
      padding: '.7em',
      fontWeight: 'bold'
    }
  return (
    <div style={style} >
      <span>{tr('bw.set.bookingsheet.fixed'+level)}</span>
      <TestButton size="medium" variant="contained" sx={{marginLeft:'1em'}} getValues={getValues} />
      <Button label="bw.set.bookingsheet.dismiss" onClick={()=>{setFixed(3);handleUpdate()}} variant="contained" size='medium' sx={{ ml: '1em' }} />
    </div>
  )
}

const InsertButton = ({ editor, ...props}) => {
  const selection = useSlateSelection()
  if(!selection)return null;
  const [node, path] = Editor.node(editor, editor.selection);
  return (
    <InsertInput editor={editor} node={node} path={path} icon={<AddIcon />} />
  );
}

const DrawerContent = ({ editor, ...props}) => {
  const selection = useSlateSelection()

  const [nodeEntry] = Editor.nodes(editor, {
    at: selection,
    match: Text.isText,
    mode: 'lowest',
  });

  const selectedPath = nodeEntry?.[1];


  return (
    <div style={{ marginTop: '5em' }}>
    <h3>Element Attributes</h3>
    <ParentTree editor={editor} selectedPath={selectedPath} />
    </div>
  );
}

const withTables = editor => {
  //const { normalizeNode } = editor
  editor.normalizeNode = ([node, path]) => {
    //console.log([path,node])
    if (SlateElement.isElement(node)) {
      if (node.type === 'table-cell') {
        for (const [child, childPath] of Node.children(editor, path)) {
          // If child is not a valid type, normalize it
          if (!['paragraph', 'table'].includes(child.type)) {
            Transforms.setNodes(editor, { type: 'table-cell' }, { at: childPath })
          }
        }
      }
      if (node.children.length === 0) {
        Transforms.insertNodes(editor, { text: '' }, { at: path.concat(0) });
        return;
      }
    }
    //return normalizeNode([node, path])
  }
  return editor
}

const withImages = editor => {
  const { isVoid } = editor
  editor.isVoid = element => {
    return element.type === 'image' ? true : isVoid(element)
  }
  editor.insertData = data => {
    const text = data.getData('text/plain')
    const { files } = data
    if (files && files.length > 0) {
      Array.from(files).forEach(file => {
        const reader = new FileReader()
        const [mime] = file.type.split('/')
        if (mime === 'image') {
          reader.addEventListener('load', () => {
            const url = reader.result
            insertImage(editor, url)
          })
          reader.readAsDataURL(file)
        }
      })
    } else  {
      insertImage(editor, text)
    } 
  }
  return editor
}

const insertImage = (editor, url) => {
  const text = { text: '' }
  const image = { type: 'image', url, children: [text] }
  Transforms.insertNodes(editor, image)
}

const SlateList = (props) => {
  const record = useRecordContext();
  if(!record || !record.id)return null;
  return (
    <SimpleForm toolbar={null} {...props}> 

    <ErrorBoundary>
      <div style={{height: '50px', overflow: 'hidden'}}>
        <SlateEditor source="html" short={true} />
      </div>
    </ErrorBoundary>
    </SimpleForm>
  )
}

const TestButton = ({label = 'Test', getValues, ...props}) => {
  const tr = useTranslate();
  const [ dlgOpen, setDlgOpen ] = useState(false)
  const [ confirm, setConfirm ] = useState(false)
  const [ resNr, setResNr ] = useStore('bookingsheetResNr', '')
  const token = getGlobalData('token')
  const record = useRecordContext();

  const handleClick = (format) => {
    const data = getValues()
    const docId = record.id; // or record.someCustomId
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${apiPath}v1/setBookingsheet/test/${docId}`; 
    form.target = '_blank';
    form.style.display = 'none';
    const formData = {...data, ...{token: token, format: format, res_nr: resNr}}
    console.log(formData)

    // Add form fields
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = typeof formData[key] === 'object'
          ? JSON.stringify(formData[key])
          : formData[key];
        form.appendChild(input);
      }
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    //window.open(`${apiPath}v1/setBookingsheet/test/${docId}?token=${token}&format=${format}&res_nr=${resNr}&data=`+JSON.stringify(data), '_blank');
  };
  const handleMailClick = () => {
    const data = getValues()
    const formData = {...data, ...{format: 'mail', res_nr: resNr}}
    dataProvider.update('setBookingsheet/test', {id: record.id, data: formData })
    .then(res  => {
      if(res?.data?.id)(
        setConfirm(true)
      )
    })
  }
  return (
    <>
      <Button label={label} onClick={()=>setDlgOpen(true)} {...props} />
      <Dialog open={dlgOpen} onClose={()=>setDlgOpen(false)}>
        {confirm === false && 
          <>
            <DialogTitle>{tr('bw.set.bookingsheet.'+label+'dialog')}:
              <div style={{lineHeight: '1.0'}}>{record?.titel}</div>
            </DialogTitle>
            <DialogContent>
              <div>{tr('bw.set.bookingsheet.resnr_help')}</div>
              <MTextField value={resNr} onChange={(ev)=>setResNr(ev.target.value)} />
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" label="HTML" onClick={()=>handleClick('html')} />
              <Button variant="outlined" label="Text" onClick={()=>handleClick('text')} />
              <Button variant="outlined" label="PDF" onClick={()=>handleClick('pdf')} />
              <Button variant="outlined" label="eMail" onClick={()=>handleMailClick()} />
            </DialogActions>
            <div style={{textAlign: 'end', marginRight: '2.1em'}}>{tr('bw.set.bookingsheet.email_help')}: ^ </div>
            <div style={{textAlign: 'end', marginRight: '2.1em', marginBottom: '1em'}}>{record?.testemail}</div>
          </>
        }
        { confirm === true && 
          <>
          <DialogTitle>{tr('bw.set.bookingsheet.email_sent')}</DialogTitle>
          <DialogActions>
            <Button variant="outlined" label="Ok" onClick={()=>{setConfirm(false);setDlgOpen(false)} } />
          </DialogActions>
          </>
        }
      </Dialog>
    </>
  )
}

const MoveField = ({ getMoveStart, setMoveStart}) => {
  const { isLoading, sort, filterValues } = useListContext();

  if(isLoading)return null
  if(sort.field !== 'pos' || !filterValues){
    return <TextField source="pos" />
  }
  return (
    <Move getMoveStart={getMoveStart} setMoveStart={setMoveStart} endpoint="setBookingsheet" />
  )
}

const ListForm = (props) => {
  const [moveStart, setMoveStart] = useState(0);
  
  const getMoveStart = () => {
    return moveStart;
  }
  return (
    <ParamProvider>
      <List {...props} title={('bw.set.roomcattext.title')} sort={{ field: 'pos', order: 'ASC' }} 
        exporter={isHauptadmin() && props.exporter} pagination={<NoPagination />} perPage={100} >
        <Datagrid style={{ width: 'auto' }} bulkActionButtons={false} >
          <MoveField source="pos" setMoveStart={setMoveStart} getMoveStart={getMoveStart} />
          <TextField source="titel" />
          <TextField source="sprache" />
          <TextField source="dormbook" />
          <TextField source="data" />
          {isHauptadmin() &&
            <TextField source="id" textAlign="right" />
          }
          {false && <SlateList />}
          <EditButton label="" />
          <TestButton label="Display" getValues={()=>{return []}} />
          <BookingsheetCopy />
        </Datagrid>
      </List>
    </ParamProvider>
  )
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: '0' };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, errorMsg: error.message });
    console.log(["An error occurred: ", error]);
  }

  render() {
    if (this.state.hasError) {
      return <SlateEditor source="html" error={this.state.errorMsg} />;
    }
    return this.props.children;
  }
}

const CloseToolbar = ({...props}) => {
  const redirect = useRedirect();
  const { getValues } = useFormContext();
  return(
    <RToolbar>
      <SaveButton label="Save" />
      <Button label="ra.action.back" onClick={() => redirect('list', 'setBookingsheet')} variant="contained" size="medium" sx={{marginLeft:'1em'}}>
        <Backspace />
      </Button>
      <TestButton size="medium" variant="contained" sx={{marginLeft:'1em'}} getValues={getValues} />
      <DeleteButton style={{marginLeft: 'auto'}} mutationMode="pessimistic" />
    </RToolbar>
  )
}

const FileLink = ({source, title=''}) => {
  const record = useRecordContext();
  if(!record || !record[source])return
  const filename = new URL(record[source]).pathname.split('/').pop();
  return (
    <div>
      <a href={record[source]} title={title} target="_blank" rel="noreferrer">{filename}</a>
    </div>
  )
}

const EForm = ({hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  const record = useRecordContext();
  const tr = useTranslate();
  return (
  <ParamProvider>
    <SimpleForm toolbar={<CloseToolbar />} {...props} /*onKeyDown={(e) => {if(e.key === 'Enter' && !e.target.closest('[data-slate-editor]')){e.preventDefault()}}}*/ > 
      <TextInput source="titel" sx={{ width: '70%' }} helperText={false} />
      <div style={{ color: 'grey', fontSize: '0.8em', marginLeft: '1em', marginBottom: '1em' }}>
        {tr("bw.set.bookingsheet.helptitle") }
      </div>
      <ReferenceInput source="sprache" reference="setSprache" filter={{ endefr: true }} >
        <SelectInput optionText="bezeichnung" emptyText={"bw.set.bookingsheet.pleaseselect"} />
      </ReferenceInput>
      { isHauptadmin() && 
        <>
          <TextInput source="pdfconf" multiline fullWidth helperText={false} sx={{ width: '70%' }} />
          <div style={{ color: 'grey', fontSize: '0.8em', marginLeft: '1em', marginBottom: '1em' }}>
            {tr("bw.set.bookingsheet.helppdfconf").split('<br>').map((line, idx) => (
              <div key={idx}>{line}</div>
            ))}
          </div>
        </>
      }
      <SelectInput source="dormbook" choices={dormbookChoices} optionText="text" />
      <SelectInput source="data" choices={dataChoices} optionText="text" />
      { isHauptadmin() && false && <FileLink source="id_datei" title="docx file" /> }
      { isHauptadmin() && false && <FileInput source="file" accept=".doc,.docx" label={tr('bw.set.bookingsheet.docxfile')} sx={{
          border: '2px dashed #1976d2',
          borderRadius: 2,
          padding: 2,
          backgroundColor: '#f9f9f9',
          '&:hover': {
            backgroundColor: '#eef6ff',
            borderColor: '#1565c0',
          },
          width: '70%',
          mb: '2em',
        }}> 
        <FileField source="src" title="title" />
        </FileInput> 
      }
      <ErrorBoundary>
        <SlateEditor key={'sl_'+record?.id} source="html" />
      </ErrorBoundary>
      <TextInput source="text" fullWidth multiline sx={{ width: '70%' }} />
    </SimpleForm>
  </ParamProvider>
  )
};

const ListFilter = (props) => (
  <Filter {...props} >
    <TextInput source="q" alwaysOn resettable inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />
  </Filter>
);

const SetBookingsheet = {
  list: (props) => (
    <ListForm {...props} filters={<ListFilter />} />
  ),
  
  edit: (props) => (
    <Edit {...props} title='bw.bwh.image.titleEdit' mutationMode="pessimistic" queryOptions={{ refetchOnMountOrArgChange: true }}>
      <EForm {...props} />
    </Edit>
  ),
  
  create: (props) => (
    <Create {...props} title='bw.bwh.image.titleEdit' redirect="list">
      <EForm {...props} />
    </Create>
  )
}   


export default SetBookingsheet